export default __webpack_public_path__ + "static/media/panel-login.50c0b378.png";